module.exports = __webpack_public_path__ + "img/courtisia-logo-inverse.b0a875c5.svg";